import {
  NotificationTemplateRequestDTO,
  NotificationTemplateResponseDTO,
  GetNotificationTemplateListRequestDTO,
  UpdateNotificationTemplateRequestDTO,
} from 'typings/dto/notificationTemplate';
import ModelActionsService from '../ModelActionsService';
import INotificationTemplateActionsService from './INotificationTemplateActionsService';
import DIContainer from 'services/DIContainer';
import ISliceActions from 'storage/slices/ISliceActions';
import IMapper from 'utils/mappers/IMapper';
import IEntityApiService from 'services/entityApi/IEntityApiService';
import IModelApiService from 'services/entityApi/IModelApiService';
import IServerEventsService from 'services/serverEvents/IServerEventsService';
import { AppDispatch, RootState } from 'storage';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';

export default class NotificationTemplateActionsServiceImpl
  extends ModelActionsService<NotificationTemplate, NotificationTemplateRequestDTO, NotificationTemplateResponseDTO>
  implements INotificationTemplateActionsService
{
  constructor(
    modelStorageData: { name: DIContainer.ModelsWithActionServices; actions: ISliceActions<NotificationTemplate> },
    modelMapper: IMapper<NotificationTemplate, NotificationTemplateResponseDTO>,
    entityApiService: IEntityApiService,
    modelApiService: IModelApiService,
    subEntitiesApiServices: DIContainer.SubEntitiesApiServices,
    modelApiRootPath: string,
    serverEventsService: IServerEventsService,
    storageStateGetter: () => RootState,
    storageDispatch: AppDispatch
  ) {
    super(
      modelStorageData,
      modelMapper,
      entityApiService,
      modelApiService,
      subEntitiesApiServices,
      modelApiRootPath,
      serverEventsService,
      storageStateGetter,
      storageDispatch
    );
  }

  public async getList(dto?: GetNotificationTemplateListRequestDTO, filter?: LocationSearchObject, customPath?: string): Promise<void> {
    return super.getList(dto, filter, customPath || PATH_BACKEND.notificationTemplate.root + '/manual-template/list');
  }

  public async update(dto: Partial<UpdateNotificationTemplateRequestDTO>, customPath?: string): Promise<void> {
    const path = customPath ?? PATH_BACKEND.notificationTemplate.root + '/manual-template';
    return this.entityApiService.putWithCredentials(path, dto);
  }
}
